import Housing from './Housing';

const PropertyRentals = () => <Housing mode="rental" />;
export default PropertyRentals;
